import React from 'react';

import PropTypes from 'prop-types';

import theme from '@adsk/alloy-react-theme';

const ReferencePickerTitle = ({ children }) => (
  <div css={[theme.typography.heading3]}>{children}</div>
);

ReferencePickerTitle.propTypes = {
  /** Title content */
  children: PropTypes.node,
};

export default ReferencePickerTitle;
